import { render, staticRenderFns } from "./DashCard.vue?vue&type=template&id=b997af38"
import script from "./DashCard.vue?vue&type=script&lang=ts"
export * from "./DashCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports